import { AutoCompleteMulti, ISelectType, useFetch, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { scaleList } from "../../../../../../../services/scale.service";
import { TIntegrationRuleMovForm } from "./integrationRuleMovSchema";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const ScheduleThen = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TIntegrationRuleMovForm>();
  const doctorObtainMode = useWatch({ control, name: "doctorObtainMode" });

  const { sendRequest } = useFetch(scaleList);

  const [options, setOptions] = useState<ISelectType[]>([]);
  const [searchBy, setSearchBy] = useState<string>("");

  const fetchOptions = useCallback(async () => {
    if (!searchBy || searchBy.trim() === "" || searchBy.length < 3) return;
    const { data, success } = await sendRequest({ SearchBy: searchBy });
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.name,
        })),
      );
    }
  }, [sendRequest, searchBy]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  const handleSetSearchBy = useCallback((search: string) => {
    setSearchBy(search);
  }, []);

  // Escala so faz sentido no modo SCHEDULE - no modo LAST_ENCOUNTER_OF_DAY o
  // medico e resolvido pelo ultimo atendimento do dia (ver DoctorObtainMode.tsx).
  if (doctorObtainMode === "LAST_ENCOUNTER_OF_DAY") return null;

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={options}
        name="uBusIntegrationRuleMovSchedulesThen"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "schedule_then")}
        keepOpenOnSelect
        SearchAsYouTypeParams={handleSetSearchBy}
      />
    </Grid>
  );
});
